module.exports = __webpack_public_path__ + "779acb7331dafc5407baf23b3f491271.svg";